.dropdown {
  position: relative;

  &Items {
    display: block;
    z-index: 3;

    &Hidden {
      visibility: hidden;
      opacity: 0;
    }
  }
}
